<template>
  <base-section>
    <div class="container">
      <div class="row justify-content-center">
        <div class="col d-flex justify-content-center">
          <base-card class="base-card-login">
            <h2 class="title title-light title-caps text-center">{{$t('views.login.title')}}</h2>

            <p class="text text-center">Lorem ipsum dolor sit amet,  adipiscing elitnunc pariatur ultricies.</p>

            <p class="text text-red text-center" v-if="isInvalid">{{$t('errors.invalid_password')}}. <br>{{$t('messages.try_again')}}</p>

            <form class="base-form" @submit.prevent="submitForm">
              <div class="base-form-fields">
                <div class="base-form-field">
                  <input type="text" :class="{ 'error': isInvalid }" :placeholder="$t('forms.password')" v-model="userPass">
                </div>
              </div>

              <div class="base-form-footer">
                <base-button class="base-button-pri" type="submit">{{$t('buttons.enter')}}</base-button>
              </div>
            </form>
          </base-card>
        </div>
      </div>
    </div>
  </base-section>
</template>

<script>
import { mapState } from 'vuex'
import { useI18n } from "vue-i18n";

export default {
  setup() {
    const { t } = useI18n()
    return { t }
  },
  data() {
    return {
      userPass: '',
      isInvalid: false,
    }
  },
  computed: {
    ...mapState( 'loginModule', ['userLoginStatus', 'loginPass'] ),
  },
  methods: {
    submitForm() {
      if( this.loginPass === this.userPass ) {
        this.$store.commit( 'loginModule/AUTHORIZE_USER' )
        this.$router.push( '/reservation-options' )
      } else {
        this.isInvalid = true
      }
    }
  }
}
</script>